"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumRinkebyConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const MathWalletConnector_1 = require("../../Connectors/Wallets/MathWalletConnector");
const Utils_1 = require("../Utils");
const TrustWalletConnector_1 = require("../../Connectors/Wallets/TrustWalletConnector");
const MetamaskCompatibleConnector_1 = require("../../Connectors/Wallets/MetamaskCompatibleConnector");
const Factory_1 = require("../../Connectors/Factory");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
const CoinbaseConnector_1 = require("../../Connectors/Wallets/CoinbaseConnector");
const TokenPocketConnector_1 = require("../../Connectors/Wallets/TokenPocketConnector");
exports.EthereumRinkebyConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.EthereumRinkeby,
    chainId: Types_1.EthChainIds.EthRinkeby,
    publicRpc: "https://api-rinkeby.etherscan.io",
    nativeToken: Tokens_1.RinkebyNativeToken,
    wrappedToken: Tokens_1.RinkebyWrappedToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmXaeURdHVszjDuGCwM7DauTjaASfm8qBZYzETM5ehq7MD",
    multicall: {
        supported: true,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: "https://rinkeby.etherscan.io",
        address: function (address) {
            return `${this.baseUrl}/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/token/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/tx/${address}`;
        },
    },
}, [
    MetamaskConnector_1.MetamaskConnector,
    TrustWalletConnector_1.TrustWalletConnector,
    MathWalletConnector_1.MathWalletConnector,
    TokenPocketConnector_1.TokenPocketConnector,
    MetamaskCompatibleConnector_1.MetamaskCompatibleConnector,
    CoinbaseConnector_1.CoinbaseWalletConnector,
    WalletConnectConnector_1.WalletConnectConnector,
], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.EtherScan, "https://api-rinkeby.etherscan.io"),
]);
